import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { CardComponentDataProps } from '../../partials/cards/cards.utils';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { VerticalCard } from '../../partials/cards/verticalCard/VerticalCard';
import { createImageWidths } from '../../partials/image/image.utils';
import { baseUnit } from '../../../theming/baseUnitDefinition';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';

const componentConfigThemeKey = 'threeThreeVC';

interface ThreeThreeVCDataProps {
    cards: CardComponentDataProps[];
}

interface ThreeThreeVCThemeProps {
    largeVerticalGap: number;
    largeHorizontalGap: number;
    mediumVerticalGap: number;
    mediumHorizontalGap: number;
    smallHorizontalGap: number;
}

const getStyle = (themeProps: ThreeThreeVCThemeProps) => {
  const { largeHorizontalGap, largeVerticalGap, mediumHorizontalGap, mediumVerticalGap, smallHorizontalGap } = themeProps;
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      marginBottom: `${baseUnit}px`,
      [MEDIA_BREAKPOINTS.large]: {
        gridTemplateColumns: '1fr 1fr 1fr',
        gridColumnGap: `${baseUnit * largeVerticalGap}px`,
        gridRowGap: `${baseUnit * largeHorizontalGap}px`,
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridColumnGap: `${baseUnit * mediumVerticalGap}px`,
        gridTemplateColumns: '1fr 1fr',
        gridRowGap: `${baseUnit * mediumHorizontalGap}px`,
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridTemplateColumns: '1fr',
        gridRowGap: `${baseUnit * smallHorizontalGap}px`,
      },
    },
  });
};

const imageWidths = createImageWidths(450, 450, 450);

export const ThreeThreeVC: React.FunctionComponent<ThreeThreeVCDataProps> = props => {
  const { cards } = props;
  const themeProps = useTheme<ThreeThreeVCThemeProps>(componentConfigThemeKey);
  const style = getStyle(themeProps);
  return (
    <ErrorBoundary>
      <div className={css(style.wrapper)}>
        {cards.map((card => (<VerticalCard key={card.id} {...card} imageWidths={imageWidths} />)))}
      </div>
    </ErrorBoundary>
  );
};
